import React from 'react'

function TwitterIcon({ width, height, className }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.5 38.5" id="x" width={width} height={height} className={className}>
  <defs>
    <linearGradient id="a" x1="2.59" x2="35.91" y1="9.63" y2="28.87" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#646464"></stop>
      <stop offset=".72" stop-color="#1d1d1d"></stop>
      <stop offset="1"></stop>
    </linearGradient>
  </defs>
  <g>
    <g>
      <path fill="url(#a)" d="M38.5,19.25c0,.52-.02,1.03-.07,1.54-.37,4.68-2.44,8.91-5.58,12.06-3.49,3.49-8.3,5.65-13.6,5.65-1.43,0-2.82-.16-4.15-.46-.94-.2-1.84-.47-2.72-.81C5.16,34.45,0,27.42,0,19.25c0-5.29,2.17-10.11,5.65-13.6C9.14,2.16,13.95,0,19.25,0s10.11,2.16,13.6,5.65c2.18,2.19,3.85,4.9,4.79,7.92.41,1.33.68,2.71.79,4.14.01.1.02.21.02.31.04.41.05.81.05,1.23Z"></path>
      <g>
        <path fill="#161616" d="M38.5,19.25c0,.52-.02,1.03-.07,1.54-.37,4.68-2.44,8.91-5.58,12.06-3.49,3.49-8.3,5.65-13.6,5.65-1.43,0-2.82-.16-4.15-.46l-6.99-7.32,8.59-9.97-8.46-12.31h7.33l6.28,6.32,5.43-6.32h3.04l7.81,8.36c.12.4.23.81.32,1.22.04.41.05.81.05,1.23Z"></path>
        <path fill="#fff" d="M30.88,30.72h-7.33l-5.5-8.01-6.89,8.01h-3.04l8.58-9.97-8.45-12.3h7.33l5.2,7.57,6.51-7.57h3.04l-8.2,9.53,8.76,12.74ZM24.03,29.81h5.13l-8.18-11.9,7.37-8.57h-.65l-7.01,8.15-5.6-8.15h-5.13l7.88,11.46-7.75,9.01h.65l7.39-8.59,5.9,8.59ZM28.36,29.39h-3.94L10.74,9.83h3.94l13.68,19.56ZM24.89,28.49h1.73L14.21,10.74h-1.73l12.41,17.75Z"></path>
      </g>
    </g>
  </g>
</svg>
        )
}

export default TwitterIcon